import { useEffect, useRef } from 'react';

export const useOnChange = <T,>(
	value: T,
	onChange: (newValue: T, previousValue: T) => void
) => {
	const ref = useRef<T>(value);

	useEffect(() => {
		if (ref.current !== value) {
			onChange(value, ref.current);
			ref.current = value;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	}, [value]);
};
